import { AuthStorage as CoreAuthStorage } from "@taskfortress/core"

/**
 * Mobile implementation of AuthStorage for web platform
 * This uses localStorage and sessionStorage
 */
export class AuthStorage extends CoreAuthStorage {
  private static instance: AuthStorage | null = null

  /**
   * Get the singleton instance of AuthStorage
   */
  public static getInstance(): AuthStorage {
    if (!AuthStorage.instance) {
      AuthStorage.instance = new AuthStorage()
    }
    return AuthStorage.instance
  }

  // Private constructor to prevent direct instantiation
  private constructor() {
    super()
  }

  // Persistent storage implementation (localStorage)
  protected getPersistentItem(key: string): string | null {
    return localStorage.getItem(key)
  }

  protected setPersistentItem(key: string, value: string): void {
    localStorage.setItem(key, value)
  }

  protected removePersistentItem(key: string): void {
    localStorage.removeItem(key)
  }

  // Session storage implementation (sessionStorage)
  protected getSessionItem(key: string): string | null {
    return sessionStorage.getItem(key)
  }

  protected setSessionItem(key: string, value: string): void {
    sessionStorage.setItem(key, value)
  }

  protected removeSessionItem(key: string): void {
    sessionStorage.removeItem(key)
  }
}
